import { render, staticRenderFns } from "./EditShareModal.vue?vue&type=template&id=a61f1676&"
import script from "./EditShareModal.vue?vue&type=script&lang=js&"
export * from "./EditShareModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports